import React from 'react';

const formatPct = (value) => {
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return '-';
  return `%${Math.round(numeric)}`;
};

const formatEdge = (value) => {
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return '-';
  return `${numeric > 0 ? '+' : ''}${numeric.toFixed(1)}`;
};

const formatOdds = (value) => {
  const numeric = Number(value);
  if (!Number.isFinite(numeric) || numeric <= 0) return 'Yok';
  return numeric.toFixed(2);
};

const getValueTypeLabel = (variant = 'real') => {
  if (variant === 'real') return 'GERCEK VALUE BET';
  if (variant === 'near') return 'YAKIN VALUE';
  return 'PIYASA FIYATLAMIS';
};

const getTypeClass = (variant = 'real') => {
  if (variant === 'real') return 'value-type value-type-real';
  if (variant === 'near') return 'value-type value-type-near';
  return 'value-type value-type-priced';
};

const getEdgeClass = (value) => {
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return 'value-metric value-edge value-edge-neutral';
  if (numeric > 0) return 'value-metric value-edge value-edge-positive';
  if (numeric < 0) return 'value-metric value-edge value-edge-negative';
  return 'value-metric value-edge value-edge-neutral';
};

const getConfidenceClass = (value = 0) => {
  const numeric = Number(value || 0);
  if (numeric >= 80) return 'value-metric value-confidence value-confidence-hot';
  if (numeric >= 70) return 'value-metric value-confidence value-confidence-good';
  return 'value-metric value-confidence value-confidence-mid';
};

const getLeagueName = (match = {}) =>
  String(match?.league?.name || match?.leagueName || match?.league || 'Lig bilgisi').trim() || 'Lig bilgisi';

const getTeamName = (team, fallback = '-') => {
  if (typeof team === 'string' && team.trim()) return team.trim();
  if (team && typeof team === 'object' && typeof team.name === 'string' && team.name.trim()) {
    return team.name.trim();
  }
  return fallback;
};

const getTeamLogo = (match = {}, side = 'home') => {
  if (side === 'home') {
    return match?.homeLogo ||
      match?.teams?.home?.logo ||
      match?.homeTeam?.logo ||
      match?.home?.logo ||
      '';
  }

  return match?.awayLogo ||
    match?.teams?.away?.logo ||
    match?.awayTeam?.logo ||
    match?.away?.logo ||
    '';
};

const normalizeReason = (item = {}) =>
  String(item?.description || item?.reason || '').trim() || 'Model, oran ve piyasa olasiligi birlikte incelenerek value sinifi belirlendi.';

const OpportunityCard = ({ item, variant = 'real' }) => {
  const match = item?.match || {};
  const homeName = getTeamName(match?.homeTeam || match?.home, 'Ev sahibi');
  const awayName = getTeamName(match?.awayTeam || match?.away, 'Deplasman');
  const homeLogo = getTeamLogo(match, 'home');
  const awayLogo = getTeamLogo(match, 'away');
  const league = getLeagueName(match);
  const market = String(item?.selection || item?.market || 'Model Yonu').trim() || 'Model Yonu';
  const oddsSource = String(item?.bookmaker || item?.oddsSource || '').trim().toLowerCase();
  const oddsSourceLabel = oddsSource ? ` (${oddsSource})` : '';
  const kickoff = match?.date
    ? new Date(match.date).toLocaleString('tr-TR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })
    : '--';

  return (
    <article className="value-op-card">
      <div className="value-op-top">
        <span className="value-league-pill">{league}</span>
        <span className={getTypeClass(variant)}>{getValueTypeLabel(variant)}</span>
      </div>

      <div className="value-match-line">
        <div className="value-team value-team-home">
          {homeLogo ? <img src={homeLogo} alt={homeName} className="value-team-logo" /> : null}
          <span title={homeName}>{homeName}</span>
        </div>

        <span className="value-separator">vs</span>

        <div className="value-team value-team-away">
          <span title={awayName}>{awayName}</span>
          {awayLogo ? <img src={awayLogo} alt={awayName} className="value-team-logo" /> : null}
        </div>
      </div>

      <div className="value-market-panel">
        <span className="value-market-label">Market</span>
        <strong className="value-market-name">{market}</strong>
      </div>

      <div className="value-metric-grid">
        <span className="value-metric">TR Oran {formatOdds(item?.turkishOdds ?? item?.odds)}{oddsSourceLabel}</span>
        <span className="value-metric">Model {formatPct(item?.modelProbability)}</span>
        <span className="value-metric">Piyasa {formatPct(item?.impliedProbability)}</span>
        <span className={getEdgeClass(item?.edge)}>Edge {formatEdge(item?.edge)}</span>
        <span className={getConfidenceClass(item?.confidence)}>Guven {formatPct(item?.confidence)}</span>
        <span className="value-metric value-kickoff">{kickoff}</span>
      </div>

      <p className="value-op-copy">{normalizeReason(item)}</p>
    </article>
  );
};

export default OpportunityCard;
